// @ts-expect-error Could not find a declaration file for module
import Client from 'AdsUI/data/Client';
import PortalIdParser from 'PortalIdParser';
export const COUPON_CAMPAIGN_KEY = 'Ads:SignupFrom2019Campaign';
export default {
  fetch() {
    return Client.apiRequest(`hubs-settings/v1/settings`, {
      query: {
        key: COUPON_CAMPAIGN_KEY
      }
    });
  },

  save({
    key,
    value
  }) {
    const PORTAL_ID = PortalIdParser.get();
    return Client.apiRequest(`hubs-settings/v1/hubs/${PORTAL_ID}/settings`, {
      type: 'POST',
      data: {
        key,
        value
      }
    });
  },

  getPortalInfo() {
    const PORTAL_ID = PortalIdParser.get();
    return Client.apiRequest(`hubs/v1/hubs/${PORTAL_ID}`);
  }

};
export const getHubs2Info = () => {
  const PORTAL_ID = PortalIdParser.get();
  return Client.apiRequest(`hubs2/v1/info/hub/${PORTAL_ID}`);
};